import { render, staticRenderFns } from "./AccountPayments.vue?vue&type=template&id=6c4b642d&scoped=true"
import script from "./AccountPayments.vue?vue&type=script&lang=js"
export * from "./AccountPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4b642d",
  null
  
)

export default component.exports